<template>
  <main-layout>
    <v-container fluid>
      <v-layout row align-center>
        <v-flex xs12 sm6>
          <h1>
            {{ $t('follow_up.title') }}
          </h1>
        </v-flex>
        <v-flex xs12 sm6>
          <div style="display: flex; justify-content: flex-end; width: 100%">
            <v-btn-toggle v-model="toggle_view_type" mandatory dense>
              <v-btn flat value="calendar">
                <em class="far fa-calendar-alt" style="font-size: 18px" />
                <span class="ml-1">{{ $t('follow_up.calendar') }}</span>
              </v-btn>
              <v-btn flat value="list">
                <em class="fas fa-list" style="font-size: 18px" />
                <span class="ml-1">{{ $t('follow_up.list') }}</span>
              </v-btn>
            </v-btn-toggle>
          </div></v-flex
        >
      </v-layout>

      <v-divider class="mt-4"></v-divider>

      <div class="mt-4">
        <template v-if="toggle_view_type === 'calendar'">
          <FollowUpCalendar />
        </template>
        <template v-if="toggle_view_type === 'list'">
          <FollowUpTable />
        </template>
      </div>
    </v-container>
  </main-layout>
</template>

<script>
import FollowUpCalendar from './FollowUpCalendar.vue'
import FollowUpTable from './FollowUpTable.vue'
// import Multiselect from 'vue-multiselect'

export default {
  components: {
    FollowUpCalendar,
    FollowUpTable
    // Multiselect
  },
  data() {
    return {
      toggle_view_type: 'calendar'
    }
  }
}
</script>

<style scroped>
.v-btn-toggle .v-btn.v-btn--active {
  background-color: #ff706b !important;
  border-color: #ff706b !important;
  color: #fff;
}
</style>



// WEBPACK FOOTER //
// src/components/view/template/Kmb/FollowUp/FollowUp.vue